import * as React from "react";
function findPathParent(obj, arr) {
  if (!obj)
    return;
  arr.push(obj.type);
  const children = obj.props?.children;
  if (obj.type === "path" && !children) {
    return arr.pop();
  } else if (typeof children === "object") {
    if (Array.isArray(children)) {
      for (let i = 0; i < children.length; i++) {
        const result = findPathParent(children[i], arr);
        if (result) {
          break;
        }
      }
    } else {
      findPathParent(children, arr);
    }
  } else {
    arr.pop();
  }
}
function addNewStyle(newStyle) {
  let styleElement = document.getElementById("styles_js");
  if (!styleElement) {
    styleElement = document.createElement("style");
    styleElement.type = "text/css";
    styleElement.id = "styles_js";
    document.getElementsByTagName("head")[0].appendChild(styleElement);
  }
  styleElement.appendChild(document.createTextNode(newStyle));
}
function changePathStyle(props, arr, id) {
  if (!props)
    return;
  const str = arr.join(" ");
  const root = arr[0];
  const others = arr.slice(1);
  if (props.color) {
    addNewStyle(root + "#" + id + " " + others.join(" ") + " path:nth-of-type(1) {fill: " + props.color + "}");
  }
  if (props["data-hovercolor"]) {
    addNewStyle(root + "#" + id + ":hover " + others.join(" ") + " path:nth-of-type(1) {fill: " + props["data-hovercolor"] + "}");
  }
  if (props["data-activecolor"]) {
    addNewStyle(root + "#" + id + ":active " + others.join(" ") + " path:nth-of-type(1) {fill: " + props["data-activecolor"] + "}");
  }
  if (Array.isArray(props["data-twotonecolor"])) {
    addNewStyle(root + "#" + id + " " + others.join(" ") + " path:nth-of-type(1) {fill: " + props["data-twotonecolor"][0] + "}");
    addNewStyle(root + "#" + id + " " + others.join(" ") + " path:nth-of-type(2) {fill: " + props["data-twotonecolor"][1] + "}");
  }
  if (Array.isArray(props["data-hovertwotonecolor"])) {
    addNewStyle(root + "#" + id + ":hover " + others.join(" ") + " path:nth-of-type(1) {fill: " + props["data-hovertwotonecolor"][0] + "}");
    addNewStyle(root + "#" + id + ":hover " + others.join(" ") + " path:nth-of-type(2) {fill: " + props["data-hovertwotonecolor"][1] + "}");
  }
  if (Array.isArray(props["data-activetwotonecolor"])) {
    addNewStyle(root + "#" + id + ":active " + others.join(" ") + " path:nth-of-type(1) {fill: " + props["data-activetwotonecolor"][0] + "}");
    addNewStyle(root + "#" + id + ":active " + others.join(" ") + " path:nth-of-type(2) {fill: " + props["data-activetwotonecolor"][1] + "}");
  }
  if (props.width) {
    addNewStyle(root + "#" + id + "{width: " + props.width + "}");
  }
  if (props.height) {
    addNewStyle(root + "#" + id + "{height: " + props.height + "}");
  }
}
const isArrayContainsElement = (arr1, arr2) => {
  for (let i = 0; i < arr2.length; i++) {
    if (arr1.includes(arr2[i])) {
      return true;
    }
  }
  return false;
};
const OPTIONS = ["color", "data-activecolor", "data-hovercolor", "data-twotonecolor", "data-hovertwotonecolor", "data-activetwotonecolor", "width", "height"];
const SvgUploadIcon = (props) => {
  const isSetOptions = isArrayContainsElement(Object.keys(props), OPTIONS);
  const svg = /* @__PURE__ */ React.createElement("svg", { width: 41, height: 40, viewBox: "0 0 41 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", id: "upload-icon_svg_plugin_56970", ...props }, /* @__PURE__ */ React.createElement("g", { id: "Group 2570" }, /* @__PURE__ */ React.createElement("path", { id: "Union", d: "M19.6165 5.09573C19.9356 4.77662 20.3843 4.66611 20.7932 4.76422C21.0102 4.81609 21.2159 4.92667 21.3852 5.09597L28.9856 12.6971C29.1809 12.8924 29.1809 13.209 28.9856 13.4042L27.483 14.9068C27.2878 15.1021 26.9712 15.1021 26.7759 14.9068L22.0626 10.1935L22.0626 28.829C22.0626 29.1051 21.8388 29.329 21.5626 29.329H19.4376C19.1615 29.329 18.9376 29.1051 18.9376 28.829L18.9376 10.1952L14.2258 14.9071C14.0305 15.1023 13.7139 15.1023 13.5187 14.9071L12.0161 13.4045C11.8208 13.2092 11.8208 12.8926 12.0161 12.6974L19.6165 5.09573ZM6.3125 35.2704C5.62214 35.2704 5.0625 34.7108 5.0625 34.0204V27.9579C5.0625 27.6818 5.28636 27.4579 5.5625 27.4579H7.6875C7.96364 27.4579 8.1875 27.6818 8.1875 27.9579V32.1454H32.8125V27.9579C32.8125 27.6818 33.0364 27.4579 33.3125 27.4579H35.4375C35.7136 27.4579 35.9375 27.6818 35.9375 27.9579V34.0204C35.9375 34.7108 35.3779 35.2704 34.6875 35.2704H6.3125Z", fill: "#127FFF" })));
  if (isSetOptions) {
    const parents = [];
    findPathParent(svg, parents);
    const id = svg.props.id;
    changePathStyle(props, parents, id);
  }
  return svg;
};
export default SvgUploadIcon;
